/**
 * QuotaLeaderboardIcon — Mi6 custom glyph: trophy with chart bars
 * viewBox 0 0 80 80, stroke 1.5px, currentColor
 */
export default function QuotaLeaderboardIcon({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <svg
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-hidden="true"
    >
      {/* Trophy cup body */}
      <path
        d="M28 16 L52 16 L52 36 C52 44 46 50 40 52 C34 50 28 44 28 36 Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      {/* Trophy handles */}
      <path d="M28 22 C22 22 20 28 22 32 C24 36 28 36 28 36" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" fill="none" />
      <path d="M52 22 C58 22 60 28 58 32 C56 36 52 36 52 36" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" fill="none" />
      {/* Trophy stem */}
      <line x1="40" y1="52" x2="40" y2="60" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      {/* Trophy base */}
      <line x1="32" y1="60" x2="48" y2="60" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      {/* Chart bars below */}
      <rect x="16" y="50" width="6" height="14" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="24" y="44" width="6" height="20" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="56" y="44" width="6" height="20" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="64" y="50" width="6" height="14" rx="1" stroke="currentColor" strokeWidth="1.5" />
      {/* Baseline */}
      <line x1="14" y1="65" x2="72" y2="65" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity="0.4" />
    </svg>
  );
}
